/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `mass_disable` - Masowe wyłączenie
 * * `cascade_delete` - Kaskadowe usunięcie
 */
export type BulkOperationKindEnum = typeof BulkOperationKindEnum[keyof typeof BulkOperationKindEnum];


export const BulkOperationKindEnum = {
  mass_disable: 'mass_disable',
  cascade_delete: 'cascade_delete',
} as const;
